import { render, staticRenderFns } from "./FormMarketingCampaignProductManagement.vue?vue&type=template&id=f08d2b2a&scoped=true&"
import script from "./FormMarketingCampaignProductManagement.vue?vue&type=script&lang=js&"
export * from "./FormMarketingCampaignProductManagement.vue?vue&type=script&lang=js&"
import style0 from "./FormMarketingCampaignProductManagement.vue?vue&type=style&index=0&id=f08d2b2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f08d2b2a",
  null
  
)

export default component.exports